PJQ.views.settings.CustomFieldSettings = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Custom-Fields'),
		fieldModel: PJQ.models.customFields.CustomField
	},
	events: {
		'click .add-field': 'addClicked',
		'click .edit-field': 'editClicked',
		'click .delete-field': 'deleteClicked',
		'click .btn-sort-alpha': 'sortFieldsAlpha'
	},
	afterRender: function () {
		this.fieldModel = new this.options.fieldModel();
		if (this.fieldModel instanceof PJQ.models.contacts.ContactCustomField) {
			this.fieldModelName = 'contact';
		}
		else if (this.fieldModel instanceof PJQ.models.contacts.CompanyCustomField) {
			this.fieldModelName = 'company';
		}
		else if (this.fieldModel instanceof PJQ.models.projects.ProjectCustomField) {
			this.fieldModelName = 'project';
		}
		else if (this.fieldModel instanceof PJQ.models.actionItems.ActionItemCustomField) {
			this.fieldModelName = 'actionItems';
		}
		else if (this.fieldModel instanceof PJQ.models.punchlists.PunchlistCustomField) {
			this.fieldModelName = 'punchList';
		}
		else if (this.fieldModel instanceof PJQ.models.commitments.CustomField) {
			this.fieldModelName = 'commitment';
		}
		else if (this.fieldModel instanceof PJQ.models.commitments.ChangeOrderCustomField) {
			this.fieldModelName = 'commitmentChangeOrder';
		}
		else if (this.fieldModel instanceof PJQ.models.primeContracts.CustomField) {
			this.fieldModelName = 'primeContract';
		}
		else if (this.fieldModel instanceof PJQ.models.primeContracts.ChangeOrderCustomField) {
			this.fieldModelName = 'primeContractChangeOrder';
		}
		else if (this.fieldModel instanceof PJQ.models.directcosts.CustomField) {
			this.fieldModelName = 'directCost';
		}
		else if (this.fieldModel instanceof PJQ.models.invoicing.PayableInvoiceCustomField) {
			this.fieldModelName = 'payableInvoice';
		}
		else if (this.fieldModel instanceof PJQ.models.invoicing.ReceivableInvoiceCustomField) {
			this.fieldModelName = 'receivableInvoice';
		}
		else if (this.fieldModel instanceof PJQ.models.schedule.ScheduleCustomField) {
			this.fieldModelName = 'schedule';
		}
		else if (this.fieldModel instanceof PJQ.models.submittals.SubmittalCustomField) {
			this.fieldModelName = 'submittals';
		}
		else if (this.fieldModel instanceof PJQ.models.users.UserCustomField) {
			this.fieldModelName = 'user';
		}

		this.$(".custom-field-table").addClass('custom-field-table-' + this.fieldModelName);

		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$(".custom-field-table"),
			data: this.collection.models,
			isHideSearch: true,
			rowId: "cid",
			language: {
				zeroRecords: 'Click "Add New Field" to create a new custom field'
			},
			order: [0, 'asc'],
			sortableOptions: {
				data: this.collection,
				containment: ".custom-field-table-" + this.fieldModelName,
			},
			bSort: false,
			onRowDoubleClick: _.bind(function (row) {
				this.editField(row.data());
			}, this),
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editField(row.data());
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						onClick: _.bind(function (row) {
							this.deleteField(row);
						}, this)

					}
				]
			},
			columns: [
				{
					"data": "attributes.sortOrder",
					"title": "",
					"searchable": false,
					"orderable": false,
					"visible": false,
					"render": _.bind(function (data, type, row) {
						let content = '';
						if (data != null) {
							content = '<div><i class="fas fa-sort"></i></div>'
						}

						return content
					}, this)
				},
				{
					"title": "Name",
					"data": "attributes.fieldName",
					"orderable": false
				},
				{
					"title": "Type",
					"data": "attributes.fieldType",
					"orderable": false
				},
				{
					"title": "Required",
					"data": "attributes.isRequired",
					"orderable": false,
					"render": function (data) {
						return '<div>' + (data ? 'Yes' : 'No') + '</div>';
					}
				},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "85px",
					"render": function () {
						return '<div class="text-align-right show-on-row-hover"><button type="button" class="btn btn-info edit-field ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button><button type="button" class="btn btn-danger delete-field ht-30p wd-35p ml-1 fs-14"><span class="fal fa-trash"></span></button></div>';
					}
				}
			]
		});
	},
	addClicked: function () {
		let newField = new this.options.fieldModel({
			fieldName: "",
			fieldType: PJQ.constants.customFields.fieldTypes.TEXT,
			isRequired: false,
			defaultValue: "",
			description: "",
			sortOrder: this.collection.length + 1
		});
		let names = [];
		_.each(this.collection.models, function (model) {
			names.push(model.get('fieldName'))
		});
		this.editField(newField, names);
	},
	editClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr')),
			field = row.data(),
			names = [];
		_.each(this.collection.models, function (model) {
			if (field.get('fieldName') !== model.get('fieldName')) {
				names.push(model.get('fieldName'))
			}
		});
		this.editField(field, names);
	},
	editField: function (field, names) {
		new PJQ.views.settings.EditCustomFieldModal({
			model: field,
			names: names,
			newSort: _.bind(function (field) {
				this.collection.add(field);
				this.dataTable.addRow(field);
				this.dataTable.refresh();
			}, this),
			onSave: _.bind(function (field) {
				if (field.hasChanged() || field.isNew()) {
					if (field.isNew()) {
						this.collection.add(field);
						this.dataTable.addRow(field);
						this.dataTable.refresh()
					}
					field.save(null, {
						notify: true,
						success: _.bind(function () {
							field.fetch({
								success: _.bind(function () {
									this.dataTable.refresh();

									PJQ.notifications.notify.successNotify({
										message: 'Custom field saved successfully'
									});
								}, this)
							});
						}, this)
					});
				}
			}, this),
			onClose: _.bind(function (field) {
				if (field ? field.hasChanged() : field) {
					field.fetch({
						success: _.bind(function () {
							this.dataTable.refresh();
						}, this)
					});
				}
			}, this),
			onDelete: _.bind(function (field) {
				if (field.id > 0) {
					let row = this.dataTable.getRow(field.cid);
					this.collection.remove(field);
					field.destroy();
					if (row != null) {
						this.dataTable.removeRow(row);
					}
				}
			}, this)
		});
	},
	deleteClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.deleteField(row);
	},
	deleteField: function (row) {
		let field = row.data();
		let sortNumber = field.attributes.sortOrder;
		_.each(this.collection.models, function (model) {
			if (model.get('sortOrder') > sortNumber) {
				let newNumber = (model.get('sortOrder') - 1);
				model.set('sortOrder', newNumber);
			}
		});
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this field?",
			onDelete: _.bind(function () {
				this.collection.remove(field);
				field.destroy();
				this.dataTable.removeRow(row);
			}, this)
		});
	},
	fetchCollection: function () {
		this.collection.fetch();
	},
	sortFieldsAlpha: function () {
		if (this.fieldModelName === 'project') {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'settings',
						value: 'sortprojectfieldsalpha'
					},
				])
			}).put().done(_.bind(function () {
				this.collection.fetch({
					success: _.bind(function () {
						this.dataTable.render();
					}, this)
				})
			}, this));
		}
		else if (this.fieldModelName === 'contact') {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'settings',
						value: 'sortcontactfieldsalpha'
					},
				])
			}).put().done(_.bind(function () {
				this.collection.fetch({
					success: _.bind(function () {
						this.dataTable.render();
					}, this)
				})
			}, this));

		}
		else if (this.fieldModelName === 'company') {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'settings',
						value: 'sortcontactcompanyfieldsalpha'
					},
				])
			}).put().done(_.bind(function () {
				this.collection.fetch({
					success: _.bind(function () {
						this.dataTable.render();
					}, this)
				})
			}, this));

		}
		else if (this.fieldModelName === 'submittals') {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'settings',
						value: 'sortsubmittalfieldsalpha'
					},
				])
			}).put().done(_.bind(function () {
				this.collection.fetch({
					success: _.bind(function () {
						this.dataTable.render();
					}, this)
				})
			}, this));
		}
		else if (this.fieldModelName === 'user') {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'settings',
						value: 'sortuserfieldsalpha'
					},
				])
			}).put().done(_.bind(function () {
				this.collection.fetch({
					success: _.bind(function () {
						this.dataTable.render();
					}, this)
				})
			}, this));
		}
		else {
			new PJQ.ajax.Request({
				endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'settings',
						value: 'sortpunchlistfieldsalpha'
					},
				])
			}).put().done(_.bind(function () {
				this.collection.fetch({
					success: _.bind(function () {
						this.dataTable.render();
					}, this)
				})
			}, this));
		}
	}
});

PJQ.views.settings.EditCustomFieldModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Modal-Edit-Custom-Field'),
		subTemplates: {
			choice: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Custom-Field-Choice')
		},
		maxWidth: 600
	},
	events: {
		'click .btn-delete-choice': 'deleteChoice',
		'click .btn-add-choice': 'addChoice',
		'click .field-save': 'save',
		'click .field-close': 'close',
		'click .field-delete': 'delete',
		'keydown .input-default-integer': 'numbersOnly',
		'change .input-multiple-choice': 'render',
		'click .btn-sort-alpha': 'sortChoicesAlpha',
		'click .btn-is-required': 'checkAllSub',
		'colorpickerChange': 'setBGColor',
		'keyup .colorpicker-input-box': 'setBGColor',
		'change .cb-read-only': 'render'
	},
	beforeRender: function () {
		if (this.model instanceof PJQ.models.contacts.ContactCustomField) {
			this.fieldModel = 'contact';
		}
		else if (this.model instanceof PJQ.models.contacts.CompanyCustomField) {
			this.fieldModel = 'company';
		}
		else if (this.model instanceof PJQ.models.projects.ProjectCustomField) {
			this.fieldModel = 'project';
		}
		else if (this.model instanceof PJQ.models.actionItems.ActionItemCustomField) {
			this.fieldModel = 'actionItems';
		}
		else if (this.model instanceof PJQ.models.punchlists.PunchlistCustomField) {
			this.fieldModel = 'punchList';
		}
		else if (this.fieldModel instanceof PJQ.models.commitments.CustomField) {
			this.fieldModelName = 'commitment';
		}
		else if (this.fieldModel instanceof PJQ.models.commitments.ChangeOrderCustomField) {
			this.fieldModelName = 'commitmentChangeOrder';
		}
		else if (this.fieldModel instanceof PJQ.models.primeContracts.CustomField) {
			this.fieldModelName = 'primeContract';
		}
		else if (this.fieldModel instanceof PJQ.models.primeContracts.ChangeOrderCustomField) {
			this.fieldModelName = 'primeContractChangeOrder';
		}
		else if (this.fieldModel instanceof PJQ.models.directcosts.CustomField) {
			this.fieldModelName = 'directCost';
		}
		else if (this.fieldModel instanceof PJQ.models.invoicing.PayableInvoiceCustomField) {
			this.fieldModelName = 'payableInvoice';
		}
		else if (this.fieldModel instanceof PJQ.models.invoicing.ReceivableInvoiceCustomField) {
			this.fieldModelName = 'receivableInvoice';
		}
		else if (this.model instanceof PJQ.models.schedule.ScheduleCustomField) {
			this.fieldModel = 'schedule';
		}
		else if (this.model instanceof PJQ.models.submittals.SubmittalCustomField) {
			this.fieldModel = 'submittals';
		}
		else if (this.model instanceof PJQ.models.users.UserCustomField) {
			this.fieldModel = 'user';
		}
	},
	renderData: function () {
		return {
			model: this.model,
			fieldModel: this.fieldModel
		};
	},
	afterRender: function () {
		new PJQ.Binder(this.$el, this.model, {
			setDefaultValues: true,
			watchElements: [
				'input',
				'textarea'
			]
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-field-type'),
			noneSelectedText: 'Select Field Type',
			defaultValue: this.model.get('fieldType'),
			onChange: _.bind(function (value) {
				this.model.set({
					fieldType: value.toUpperCase(),
					defaultValue: ""
				});
				this.render();
			}, this),
		});
		if(this.fieldModel === "project"){
			this.renderColorPicker();
		}

		if (this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.DATE || this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.DATETIME) {
			new PJQ.inputs.Datepicker({
				el: this.$('.input-default-date'),
				isShowTimezone: false,
				datepickerOptions: {
					defaultDate: this.model.get('defaultValue'),
					format: this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.DATE ? PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE : PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE_TIME
				},
				onChange: _.bind(function (value) {
					this.model.set('defaultValue', value);
				}, this),
			});
		}
		else if (this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.MONEY) {
			PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2);
		}
		else if (this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.PERCENT) {
			PJQ.helpers.inputHelpers.inputMaskDecimal(this.$('.input-decimal'), 2);
		}
		else if (this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.BOOL) {
			new PJQ.inputs.Selectpicker({
				el: this.$('.select-default-bool'),
				defaultValue: this.model.get('defaultValue'),
				onChange: _.bind(function (value) {
					if (value === "true") {
						this.model.set('defaultValue', true)
					}
					else if (value === "false") {
						this.model.set('defaultValue', false)
					}
				}, this),
			});
		}
		else if (this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.CHOICE) {
			let defaultId = null;
			if (_.size(this.model.get('defaultValue')) > 0) {
				let defaultChoice = "";
				_.each(this.model.choices.models, function (choice) {
					if (choice.get('id') == this.model.get('defaultValue')) {
						defaultChoice += choice.cid
					}
				}, this);
				if (defaultChoice != null) {
					defaultId = defaultChoice
				}
			}
			this.choicePicker = new PJQ.inputs.Selectpicker({
				el: this.$('.select-default-choice'),
				defaultValue: defaultId,
				onChange: _.bind(function (value) {
					let choice = this.model.choices.get(value);
					if(choice == null){
						this.model.set('defaultValue', null);
					}
					else if(choice.get('id') > 0) {
						this.model.set('defaultValue', choice.get('id'));
					}
					else{
						choice.set('isDefault', true);
					}
				}, this),
			});
			this.updateChoicePicker();
			this.renderChoices();
		}
	},
	updateChoicePicker: function () {
		this.choicePicker.updateChoices(_.map(this.model.choices.models, function (choice) {
			return {
				id: choice.cid,
				name: choice.get('choiceName')
			};
		}));
	},
	renderChoices: function () {
		let $choices = this.$('.custom-field-choices');
		$choices.empty();
		if (_.size(this.model.choices.models) > 0) {
			_.each(_.sortBy(_.filter(this.model.choices.models, function (model) {
				return !model.get('isDeleted');
			}), function (model) {
				return model.get('sortOrder');
			}), _.bind(function (choice) {
				this.renderChoice(choice);
			}, this));
		}
		else {
			$choices.append($('<div>', {
				class: 'no-choices-text fs-16 font-weight-light text-muted text-align-center mt-2 mb-2',
				text: 'No choices added yet'
			}));
		}
	},
	renderChoice: function (choice) {
		let $choices = this.$('.custom-field-choices');
		$choices.find('.no-choices-text').remove();
		this.renderSubTemplate(true, this.options.subTemplates.choice, $choices, {
			model: choice
		}, _.bind(function ($choice) {
			new PJQ.Binder($choice, choice, {
				setDefaultValues: true,
				watchElements: [
					'input'
				],
				afterChange: _.bind(function () {
					this.model.isDirty = true;
					this.updateChoicePicker();
				}, this)
			});
		}, this));
		let self = this;
		self.fieldSortable = new PJQ.Sortable(self.$('.custom-field-choices'), {
			containment: "parent",
			items: '.custom-field-choice',
			connectWith: '.custom-field-choice',
			onStop: function () {
				self.$('.custom-field-choice').each(function (index) {
					let name = $(this).data('name'),
						sortItem = _.find(self.model.choices.models, function (choice) {
							return choice.get('choiceName') === name
						}),
						sortOrder = index + 1;
					sortItem.set('sortOrder', sortOrder);
				});
				self.model.save();
			}
		});
	},
	renderColorPicker: function (e) {
		this.colorPicker = new PJQ.colors.ColorPicker(this.$('.color-picker'), {
			format: 'hex',
			color: _.size(this.model.get('color')) > 0 ? this.model.get('color') : '#000000',
			autoInputFallback: false
		});
		this.$('.colorpicker-input-box').val(_.size(this.model.get('color')) > 0 ? this.model.get('color') : '#000000');
	},
	setBGColor: function (e) {
		if (e.type === 'keyup') {
			if (e.keyCode === 13) {
				$(e.currentTarget).blur()
			}
			let color = this.$('.colorpicker-input-box').val();
			if (color.split('')[0] === '#' && color.trim().length === 7) {
				this.colorPicker.setColor(color);
				this.model.set('color', color.toUpperCase());
				PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), true);
			}
		}

		else {
			let color = this.colorPicker.getColor();
			if (color.split('')[0] === '#' && color.trim().length === 7) {
				this.$('.colorpicker-input-box').val(color);
				this.model.set('color', color);
				PJQ.helpers.inputHelpers.setInputError(this.$('.colorpicker-input-box'), true);
			}
		}
	},
	validate: function () {
		let isValid = true,
			isDuplicate = false;

		PJQ.helpers.inputHelpers.setInputError(this.$('.input-field-name'), true);
		_.each(this.options.names, function (name) {
			if (this.$('.input-field-name').val().trim() === name) {
				isValid = false;
				isDuplicate = true;
				PJQ.helpers.inputHelpers.setInputError(this.$('.input-field-name'), false)
			}
		}, this);

		if (this.$('.input-field-name').val().trim().length === 0) {
			isValid = false;
			PJQ.helpers.inputHelpers.setInputError(this.$('.input-field-name'), false);
		}

		if (this.model.get('fieldType') === PJQ.constants.customFields.fieldTypes.CHOICE) {
			$('.input-custom-field-choice-name').each(function () {
				let $choice = $(this);
				if ($choice.val().trim().length === 0) {
					isValid = false;
					PJQ.helpers.inputHelpers.setInputError($choice, false);
				}
				else {
					PJQ.helpers.inputHelpers.setInputError($choice, true);
				}
			})
		}

		if (!isValid && isDuplicate) {
			new PJQ.Alert(this.$('.validation-error'), {
				type: 'danger',
				text: 'Field name already exists!'
			})
		}
		else if (!isValid) {
			new PJQ.Alert(this.$('.validation-error'), {
				type: 'danger',
				text: 'Required fields are empty'
			});
		}
		else {
			this.$('.validation-error').empty();
		}
		return isValid;
	},
	addChoice: function () {
		let newChoice = new PJQ.models.customFields.CustomFieldChoice({
			choiceName: "",
			sortOrder: _.size(this.model.choices.models) + 1
		});
		this.model.choices.add(newChoice);
		this.renderChoice(newChoice);
		this.$('.input-custom-field-choice-name').last().focus();
		this.updateChoicePicker();
	},
	deleteChoice: function (e) {
		let $choice = $(e.currentTarget).closest('.custom-field-choice'),
			cid = $choice.data('cid'),
			choice = this.model.choices.get(cid);

		if (choice.id > 0) {
			choice.set('isDeleted', true);
			this.model.isDirty = true;
		}
		else {
			this.model.choices.remove(cid);
		}
		$choice.remove();

		if (this.model.get('defaultValue') === choice.id)
			this.model.set('defaultValue', null);

		this.updateChoicePicker();
	},
	checkAllSub: function(e) {
		let isChecked = e.target.checked;
		let $visible = this.$('.btn-is-visible'),
			$editable = this.$('.btn-is-editable')
		if(this.fieldModel === 'contact' || this.fieldModel === 'company') {
			$visible.attr('disabled', isChecked);
			$editable.attr('disabled', isChecked);
			if (isChecked) {
				this.model.set('isVisibleInRSVP', true)
				this.model.set('isChangeableInRSVP', true)
				$visible[0].checked = true;
				$editable[0].checked = true;
			}
		}
	},
	save: function () {
		if (!this.validate())
			return;

		if (this.options.onSave) {
			this.options.onSave(this.model);
			this.removeModal();
		}
	},
	close: function () {
		if (this.model.hasChanged()) {
			new PJQ.views.modals.SaveDontSave({
				header: "Unsaved Changes",
				body: "Do you want to save changes?",
				onSave: _.bind(function () {
					this.save();
				}, this),
				onDontSave: _.bind(function () {
					if (this.options.onClose) {
						this.options.onClose(this.model);
					}
					this.removeModal();
				}, this)
			});
		}
		else if (this.options.onClose) {
			this.options.onClose(this.model);
			this.removeModal();
		}
	},
	numbersOnly: function (e) {
		return PJQ.helpers.inputHelpers.numbersOnly(e);
	},
	delete: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this field?",
			onDelete: _.bind(function () {
				if (this.options.onDelete) {
					this.options.onDelete(this.model);
				}
				this.removeModal();
			}, this)
		});
	},
	fetchModel: function () {
		this.model.fetch();
	},
	sortChoicesAlpha: function () {
		let newModel;
		if (this.model.isNew()) {
			newModel = true;
		}
		this.model.save(null, {
			success: _.bind(function () {
				if (this.fieldModel === 'project') {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'settings'
							},
							{
								endpoint: 'sortprojectchoicesalpha',
								value: this.model.get('id')
							},
						])
					}).put().done(_.bind(function () {
						this.model.fetch({
							success: _.bind(function () {
								this.render();
								if (newModel) {
									this.options.newSort(this.model);
								}
							}, this)
						})
					}, this));
				}
				else if (this.fieldModel === 'contact') {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'settings'
							},
							{
								endpoint: 'sortcontactchoicesalpha',
								value: this.model.get('id')
							},
						])
					}).put().done(_.bind(function () {
						this.model.fetch({
							success: _.bind(function () {
								this.render();
								if (newModel) {
									this.options.newSort(this.model);
								}
							}, this)
						})
					}, this));
				}
				else if (this.fieldModel === 'company') {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'settings'
							},
							{
								endpoint: 'sortcontactcompanychoicesalpha',
								value: this.model.get('id')
							},
						])
					}).put().done(_.bind(function () {
						this.model.fetch({
							success: _.bind(function () {
								this.render();
								if (newModel) {
									this.options.newSort(this.model);
								}
							}, this)
						})
					}, this));
				}
				else if (this.fieldModel === 'submittals') {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'settings'
							},
							{
								endpoint: 'sortsubmittalchoicesalpha',
								value: this.model.get('id')
							},
						])
					}).put().done(_.bind(function () {
						this.model.fetch({
							success: _.bind(function () {
								this.render();
								if (newModel) {
									this.options.newSort(this.model);
								}
							}, this)
						})
					}, this));
				}
				else if (this.fieldModel === 'user') {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'settings'
							},
							{
								endpoint: 'sortuserchoicesalpha',
								value: this.model.get('id')
							},
						])
					}).put().done(_.bind(function () {
						this.model.fetch({
							success: _.bind(function () {
								this.render();
								if (newModel) {
									this.options.newSort(this.model);
								}
							}, this)
						})
					}, this));
				}
				else {
					new PJQ.ajax.Request({
						endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
							{
								endpoint: 'settings'
							},
							{
								endpoint: 'sortpunchlistchoicesalpha',
								value: this.model.get('id')
							},
						])
					}).put().done(_.bind(function () {
						this.model.fetch({
							success: _.bind(function () {
								this.render();
								if (newModel) {
									this.options.newSort(this.model);
								}
							}, this)
						})
					}, this));
				}
			}, this)
		});
	}
});
